import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks
 * @param {string} html - Raw HTML string to sanitize
 * @param {Object} options - Optional DOMPurify configuration
 * @returns {string} Sanitized HTML string
 */
export const sanitizeHtml = (html, options = {}) => {
  if (!html) return '';
  
  // Default configuration - allow safe HTML tags
  const defaultConfig = {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'b', 'i', 'u', 's', 'strike',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li',
      'a', 'span', 'div',
      'blockquote', 'pre', 'code',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'img', 'figure', 'figcaption',
      'hr', 'sub', 'sup'
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel', 'class', 'id', 'style',
      'src', 'alt', 'width', 'height', 'title'
    ],
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'], // Allow target attribute for links
    ...options
  };

  return DOMPurify.sanitize(html, defaultConfig);
};

/**
 * Create a sanitized HTML object for dangerouslySetInnerHTML
 * @param {string} html - Raw HTML string to sanitize
 * @param {Object} options - Optional DOMPurify configuration
 * @returns {{ __html: string }} Object safe for dangerouslySetInnerHTML
 */
export const createSanitizedMarkup = (html, options = {}) => {
  return { __html: sanitizeHtml(html, options) };
};

export default sanitizeHtml;
